import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteAnaliseMercadoStatusProjetadoBadgeComponent, ClienteAnaliseMercadoStatusProjetadoBadgeNaoProjetadoComponent, ClienteAnaliseMercadoStatusProjetadoBadgeProjetadoComponent, ClienteAnaliseMercadoStatusProjetadoBadgeEmNegociacaoComponent, ClienteAnaliseMercadoStatusProjetadoBadgeGanhoComponent, ClienteAnaliseMercadoStatusProjetadoBadgePerdidoComponent } from './badge';
import { ClienteAnaliseMercadoStatusProjetadoBadgePillComponent, ClienteAnaliseMercadoStatusProjetadoBadgePillNaoProjetadoComponent, ClienteAnaliseMercadoStatusProjetadoBadgePillProjetadoComponent, ClienteAnaliseMercadoStatusProjetadoBadgePillEmNegociacaoComponent, ClienteAnaliseMercadoStatusProjetadoBadgePillGanhoComponent, ClienteAnaliseMercadoStatusProjetadoBadgePillPerdidoComponent } from './badge-pill';
import { ClienteAnaliseMercadoStatusProjetadoMultiselectComponent } from './multiselect';

import { ClienteAnaliseMercadoStatusProjetadoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        // Badge
        ClienteAnaliseMercadoStatusProjetadoBadgeComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeNaoProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeEmNegociacaoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeGanhoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePerdidoComponent,
        // Badge Pill
        ClienteAnaliseMercadoStatusProjetadoBadgePillComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillNaoProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillEmNegociacaoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillGanhoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillPerdidoComponent,
        // Multiselect
        ClienteAnaliseMercadoStatusProjetadoMultiselectComponent,

        // Pipes
        ClienteAnaliseMercadoStatusProjetadoPipe
    ],
    exports: [
        SharedModule,

        // Badge
        ClienteAnaliseMercadoStatusProjetadoBadgeComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeNaoProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeEmNegociacaoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgeGanhoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePerdidoComponent,
        // Badge Pill
        ClienteAnaliseMercadoStatusProjetadoBadgePillComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillNaoProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillProjetadoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillEmNegociacaoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillGanhoComponent,
        ClienteAnaliseMercadoStatusProjetadoBadgePillPerdidoComponent,
        // Multiselect
        ClienteAnaliseMercadoStatusProjetadoMultiselectComponent,

        // Pipes
        ClienteAnaliseMercadoStatusProjetadoPipe
    ],
    providers: [
        // Pipes
        ClienteAnaliseMercadoStatusProjetadoPipe
    ]
})
export class ClienteAnaliseMercadoStatusProjetadoModule { }
